import {Component, inject, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import {NgxPermissionsModule} from 'ngx-permissions';
import {Observable} from 'rxjs';
import {UserService} from '../../services/user.service';
import {UserVM} from '../../models/user/user-vm.model';
import {environment} from '../../../environments/environment';
import {tap} from 'rxjs/operators';
import {MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule, RouterModule, NgxPermissionsModule],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  public currentUser$: Observable<UserVM>;
  public companyName: string;
  private userService = inject(UserService);
  private dialog = inject(MatDialog);

  ngOnInit(): void {
   this.userService.getUserCompaniesAsObs().pipe(
     tap(userCompanies => {
       const managedCompany = +localStorage.getItem('managedCompanyId');
       if (managedCompany) {
         this.companyName = userCompanies.find((company) => company.id === managedCompany)?.name;
       }
     })
   ).subscribe();
   this.currentUser$ = this.userService.getCurrentUserAsObs();
  }

  protected readonly environment = environment;

  async openCyprusRegistrySearch(): Promise<void> {
    // Lazy-load so jsPDF + xlsx (pulled in by this dialog) stay out of the eager bundle.
    const {CyprusRegistrySearchComponent} = await import('../../home/cyprus-registry-search/cyprus-registry-search.component');
    this.dialog.open(CyprusRegistrySearchComponent, {
      width: '960px',
      maxWidth: '95vw',
      autoFocus: false
    });
  }
}
